import React from 'react';
import './App.css';
import HomePage from './homePage';

function App() {
  return <HomePage />;
}

export default App;